import React from 'react';
import { Page } from '../Page';
import { Brain, Clock, Moon } from 'lucide-react';
export function SupplementSleepSupport() {
  return <Page pageNumber={30} variant="light" data-id="element-3102">
      <div className="flex flex-col h-full" data-id="element-3103">
        <div className="mb-6 pt-4" data-id="element-3104">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-3105">
            Supplement Spotlight
          </p>
          <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-3106">
            Sleep Support
          </h1>
          <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-3107">
            Two approaches based on your needs
          </p>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-3108" />
        </div>

        <div className="mb-8" data-id="element-3109">
          <h2 className="text-sm font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3110">
            Why It Matters on GLP-1
          </h2>
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-3111">
            Sleep quality is a major lever for GLP-1 success. Poor sleep
            elevates cortisol, increases hunger hormones, and stalls weight
            loss. GLP-1 medications can also disrupt sleep patterns during dose
            adjustments. Choose the approach that best matches your sleep
            challenges.
          </p>
        </div>

        {/* 2 Bottles Row */}
        <div className="grid grid-cols-2 gap-10 mb-8" data-id="element-3112">
          <div className="flex flex-col items-center" data-id="element-3113">
            <img src="https://cdn.magicpatterns.com/uploads/uV7kMwb5546qEb7k2tWpLB/pasted-image.png" alt="Deep Sleep Complex" className="h-48 object-contain mb-4" data-id="element-3114" />
            <h3 className="text-sm font-bold text-[#1F1F1F] text-center mb-1" data-id="element-3115">
              Deep Sleep Complex
            </h3>
            <p className="text-[10px] text-[#7A7A70] text-center uppercase tracking-wider" data-id="element-3116">
              Stress-Driven Insomnia
            </p>
          </div>
          <div className="flex flex-col items-center" data-id="element-3117">
            <img src="https://cdn.magicpatterns.com/uploads/rTKAMShBVdKX1odvM4WFhY/pasted-image.png" alt="Melaton-3" className="h-48 object-contain mb-4" data-id="element-3118" />
            <h3 className="text-sm font-bold text-[#1F1F1F] text-center mb-1" data-id="element-3119">
              Melatonin (3mg or 5mg)
            </h3>
            <p className="text-[10px] text-[#7A7A70] text-center uppercase tracking-wider" data-id="element-3120">
              Circadian Rhythm Reset
            </p>
          </div>
        </div>

        {/* Comparison Cards */}
        <div className="grid grid-cols-2 gap-6 mb-6" data-id="element-3121">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 flex flex-col" data-id="element-3122">
            <Brain className="w-5 h-5 text-tealslate mb-3" data-id="element-3123" />
            <h4 className="text-xs font-bold text-[#1F1F1F] mb-2" data-id="element-3124">
              Best for a Busy Mind
            </h4>
            <p className="text-xs text-[#3B3B3B] leading-[1.6] mb-4 flex-1" data-id="element-3125">
              Melatonin-free, non-habit-forming. Uses Maizinol®, L-theanine,
              and chamomile to modulate cortisol and promote relaxation.
              <br data-id="element-3126" />
              <br data-id="element-3127" />
              <strong data-id="element-3128">Timeline:</strong> 20min stress balance → 60min relaxation
              → 1 week faster sleep onset.
            </p>
            <div className="border-t border-[#D8D8D0] pt-3 mt-auto" data-id="element-3129">
              <p className="text-[11px] font-bold text-[#1F1F1F]" data-id="element-3130">
                2 caps before bed
              </p>
              <p className="text-[10px] text-[#7A7A70]" data-id="element-3131">60 caps per bottle</p>
            </div>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 flex flex-col" data-id="element-3132">
            <Clock className="w-5 h-5 text-tealslate mb-3" data-id="element-3133" />
            <h4 className="text-xs font-bold text-[#1F1F1F] mb-2" data-id="element-3134">
              Best for Jet Lag & Shift Work
            </h4>
            <p className="text-xs text-[#3B3B3B] leading-[1.6] mb-4 flex-1" data-id="element-3135">
              Direct melatonin supplementation. Promotes the resynchronization
              of your circadian cycle and enhances GABA for relaxation. Also
              provides antioxidant and GI health benefits.
            </p>
            <div className="border-t border-[#D8D8D0] pt-3 mt-auto" data-id="element-3136">
              <p className="text-[11px] font-bold text-[#1F1F1F]" data-id="element-3137">
                1 cap at bedtime
              </p>
              <p className="text-[10px] text-[#7A7A70]" data-id="element-3138">
                60 caps per bottle (available in 3mg or 5mg)
              </p>
            </div>
          </div>
        </div>

        <div className="mt-auto flex items-center gap-3" data-id="element-3139">
          <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3140" />
          <div data-id="element-3141">
            <p className="text-xs font-bold text-[#1F1F1F]" data-id="element-3142">
              Choose Your Approach
            </p>
            <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3143">
              If you're interested in a supplement plan tailored to you, check
              out the link below! Fullscript provides third-party tested, safe
              and effective supplements to help get your health where you want
              it at wholesale prices.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}